/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Spaces_Conflict_RemainingInputs */



/**
* | output |
* | --- |
* | "{count} remaining" |
*
* @param {Spaces_Conflict_RemainingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_conflict_remaining = /** @type {((inputs: Spaces_Conflict_RemainingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Conflict_RemainingInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} verbleibend`)
	return /** @type {LocalizedString} */ (`${i?.count} remaining`)
});